import { render, staticRenderFns } from "./InsuranceTable.vue?vue&type=template&id=27a73b91&"
import script from "./InsuranceTable.vue?vue&type=script&lang=js&"
export * from "./InsuranceTable.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports